import { Text, type TextProps } from '@/ui';

export const PanelTitle = (props: TextProps) => {
  return <Text fontWeight="medium" lineHeight="1" {...props} />;
};
